import { api } from '../api';
import { WithdrawInitRequestType, WithdrawInitResponseType } from './types';
import { FIAT_WITHDRAW_INIT } from '../../constants/fiatWithdraw';

export const fiatWithdrawSlice = api.injectEndpoints({
  endpoints: (build) => ({
    withdrawInit: build.mutation<
      WithdrawInitResponseType,
      WithdrawInitRequestType
    >({
      query(data) {
        return {
          url: FIAT_WITHDRAW_INIT,
          method: 'POST',
          body: data
        };
      }
    })
  })
});

export const { useWithdrawInitMutation } = fiatWithdrawSlice;
